import React, { useState } from 'react'
import {AccordionItem,AccordionItemHeading,
  AccordionItemPanel,
  AccordionItemButton,
  AccordionItemState
} from 'react-accessible-accordion'
import "react-accessible-accordion/dist/fancy-example.css"
import {MdOutlineArrowDropDown} from "react-icons/md"
const ValueAccordion = ({item,i}) => {
    const [className ,setClassName] =useState("collapsed") 
   
    return (
        <AccordionItem className={`accordionItem ${className}`} key={i} uuid={i}>
            <AccordionItemHeading>
                <AccordionItemButton className='flexCenter accordionButton'>
                    <AccordionItemState>
                        {({expanded}) => expanded ? setClassName("expanded") : setClassName("collapsed")}
                    </AccordionItemState>
                    <div className="flexCenter icon">
                        {item.icon}
                    </div>
                    <span className="primaryText">
                        {item.heading}
                    </span>
                    <div className="flexCenter icon">
                        <MdOutlineArrowDropDown size={20} />

                    </div>
                </AccordionItemButton>
            </AccordionItemHeading>
            <AccordionItemPanel>
                <p className="secondaryText">{item.detail}</p>
            </AccordionItemPanel>
        </AccordionItem>
    )
}

export default ValueAccordion